import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { Badge, Card, Modal, Button, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import Block from "../../components/Block/Block";
import { Icon } from "../../components";
import DebounceSearchInput from "../Constant/DebounceSearchInput";
import { busstatusoption } from "../../utilities";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { IoCloseOutline } from "react-icons/io5";
import { createStopApi, getStopListApi } from "../../services/TransportService";
import Stopmap from "./Stopmap";
import maplogo from "../../Images/maplogo.png";
import { Spinner } from "react-bootstrap";
import Stopaddmap from "./Stopaddmap";
import Addstopmodal from "./Addstopmodal";
import { toast } from "react-toastify";
function StopListPage({ userRole }) {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
   const [isAddSubmiting, setIsAddSubmiting] = useState(false);
     const [modalVisible, setModalVisible] = useState(false);
  // const [isAddSubmiting, setIsAddSubmiting] = useState(false);
  const [selectItem, setSelectitem] = useState(null);
  const [mapOpen, setMapopen] = useState(false);
  const[selectedstatus,setSelectedStatus]=useState({})
  const handleOpen = () => setMapopen(true);
  const handleClose = () => setMapopen(false);
  // const [markerPosition, setMarkerPosition] = useState(null);
  // useEffect(() => {
  //   setAddFormFields({
  //     ...addFormFields,
  //     longitude: markerPosition?.lng || "",
  //     latitude: markerPosition?.lat || "",
  //   });
  //   if (markerPosition?.lat && markerPosition?.lng) {
  //     seterrorFormFields({ ...adderrorFields, latitude: "", longitude: "" });
  //   }
  // }, [markerPosition]);
  // const [addFormFields, setAddFormFields] = useState({
  //   name: "",
  //   longitude: "",
  //   latitude: "",
  // });
  // const [adderrorFields, seterrorFormFields] = useState({
  //   name: "",
  //   longitude: "",
  //   latitude: "",
  // });

  const [filter, setFilter] = useState({
    // page: 1,
    // page_size: 12,
    query: "",
    status: "",
  });

  const fetchData = useCallback(() => {
    setIsLoading(true);
    getStopListApi(filter)
      .then((resp) => {
        setData(resp.data);
        setTotal(resp.data?.total || 0);
      })
      .catch((error) => {
        console.error(error?.response?.data?.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [filter.currentPage, filter.query, filter.status]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handlePageChange = (page) => {
    setFilter((prev) => ({
      ...prev,
      page: page,
    }));
  };

  const handleSearchChange = (value) => {
    setFilter((prev) => ({
      ...prev,
      page: 1,
      query: value,
    }));
  };

  // const handleToggleModal = () => {
  //   if (!modalVisible) {
  //     setAddFormFields({
  //       name: "",
  //       longitude: "",
  //       latitude: "",
  //     });
  //     seterrorFormFields({
  //       name: "",
  //       longitude: "",
  //       latitude: "",
  //     });
  //     setMarkerPosition(null);
  //   }
  //   setModalVisible((prev) => !prev);
  // };

  // const handleSubmit = () => {
  //   console.log(markerPosition);
  //   let valid = true;
  //   const error = { name: "", longitude: "", latitude: "" };
  //   if (!addFormFields?.name) {
  //     error.name = "Mandatory Field";
  //     valid = false;
  //   }
  //   if (!addFormFields?.longitude) {
  //     error.longitude = "Mandatory Field";
  //     valid = false;
  //   }
  //   if (!addFormFields?.latitude) {
  //     error.latitude = "Mandatory Field";
  //     valid = false;
  //   }
  //   seterrorFormFields(error);
  //   if (valid) {
  //     // alert(JSON.stringify(addFormFields));
  //     setIsAddSubmiting(true);
  //     createStopApi(addFormFields)
  //       .then((resp) => {
  //         setData((prev) => [resp.data, ...prev]);
  //         setTotal((prev) => prev + 1);
  //         handleToggleModal();
  //       })
  //       .catch((error) => {
  //         console.error(error?.response?.data?.message);
  //       })
  //       .finally(() => {
  //         setIsAddSubmiting(false);
  //       });
  //   }
  // };
const handlesubmit=(data)=>{
  // alert(JSON.stringify(data))
    setIsAddSubmiting(true);
      createStopApi(data)
        .then((resp) => {
          setData((prev) => [resp.data, ...prev]);
          setTotal((prev) => prev + 1);
          setModalVisible(false)
          toast.success('Created successfully')
        })
        .catch((error) => {
          console.error(error?.response?.data?.message);
        })
        .finally(() => {
          setIsAddSubmiting(false);
        });
}
  return (
    <div>
      <Block.Head>
        <Block.HeadBetween>
          <Block.HeadContent>
            <Block.Title tag="h2">Stops</Block.Title>
            <nav>
              <ol className="breadcrumb breadcrumb-arrow mb-0">
                <li className="breadcrumb-item">
                  <Link to="/">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Stops
                </li>
              </ol>
            </nav>
          </Block.HeadContent>

          <Block.HeadContent>
            <ul className="d-flex">
              <li className="me-2">
                <DebounceSearchInput
                  handleSearchChange={handleSearchChange}
                  placeholder="Search Stop.."
                />
              </li>
              <li>
                {userRole === "Admin" && (
                  <Button
                    className="d-md-inline-flex"
                    variant="primary"
                    onClick={()=>setModalVisible(true)}
                  >
                    <Icon name="plus" />
                    <span>Add Stop</span>
                  </Button>
                )}
              </li>
            </ul>
          </Block.HeadContent>
        </Block.HeadBetween>
      </Block.Head>
      <Block>
        {isLoading ? (
          <div className="d-flex justify-content-center align-items-center p-3">
            <Spinner animation="border" size="sm" />
            <span className="ms-1">Loading...</span>
          </div>
        ) : (
          <Row>
            {data.map((item, index) => (
              <Col xs={12} sm={6} md={4} lg={3} key={index} className="mb-3">
                <Card className="card-hover-shadow">
                  <Card.Body className="p-0">
                    <div className="d-flex justify-content-between align-items-center px-3 mt-2">
                      <div>
                        <h5>{item.name}</h5>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center p-3">
                      <Link
                        to={`/stop/${item.id}`}
                        className="btn btn-outline-primary btn-sm"
                      >
                        View Details{" "}
                        <Icon className={"ms-1"} name="arrow-right" />
                      </Link>
                      <a
                        // target="_blank"
                        // rel="noopener noreferrer"
                        // href={`https://maps.google.com/q=${item.latitude},${item.longitude}`}
                        className="cursor-pointer"
                        onClick={() => {
                          setSelectitem(item);
                          handleOpen();
                        }}
                      >
                        {/* View In Map <Icon name="map-pin" className="me-1" /> */}
                        <img src={maplogo} height="22px" width="22px" />
                      </a>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        )}

        <Addstopmodal title="Create Stop" modalVisible={modalVisible} setModalVisible={setModalVisible} onsubmit={handlesubmit} isAddSubmiting={isAddSubmiting}/>
        <Dialog open={mapOpen} onClose={handleClose} fullWidth maxWidth="md">
          <DialogTitle sx={{ m: 0, p: 2 }}>
            Map View
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <IoCloseOutline />
            </IconButton>
          </DialogTitle>
          <DialogContent
            dividers
            sx={{
              p: "0", // fixed height in px
            }}
          >
            <DialogContentText
              sx={{
                p: "0", // fixed height in px
              }}
            >
              <Stopmap data={selectItem} />
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </Block>
    </div>
  );
}

const mapStateToProps = (state) => ({
  userRole: state.auth.user?.role || "Employee",
});

export default connect(mapStateToProps)(StopListPage);
